/**
 * Composable pour gérer les statuts des plannings et meetings
 * Centralise la logique des statuts qui est répétée dans plusieurs composants
 */

import {
  ALLOWED_SESSION_DURATIONS,
  PLANNING_STATUS_CLASSES,
  PLANNING_STATUS_LABELS,
} from "@/constants/planning";

export function usePlanningStatus() {
  const getStatusText = (statusCode) => {
    return PLANNING_STATUS_LABELS[statusCode] || "Inconnu";
  };

  const getStatusClass = (statusCode) => {
    return PLANNING_STATUS_CLASSES[statusCode] || "";
  };

  const getMeetingStats = (meetings) => {
    const stats = {};
    Object.keys(PLANNING_STATUS_LABELS).forEach((s) => (stats[s] = 0));
    meetings.forEach((m) => stats[m.statut] !== undefined && stats[m.statut]++);
    return Object.keys(stats)
      .map((s) => ({
        status: +s,
        label: PLANNING_STATUS_LABELS[s],
        count: stats[s],
      }))
      .filter((s) => s.count > 0);
  };

  const buildStatsTitle = (meetings) => {
    return getMeetingStats(meetings).map(
      (stat) => `${stat.label}: ${stat.count}`
    );
  };

  return {
    PLANNING_STATUS_LABELS,
    ALLOWED_SESSION_DURATIONS,
    getStatusText,
    getStatusClass,
    getMeetingStats,
    buildStatsTitle,
  };
}
